angular.module('TInv.REST', []
).factory('REST', function ($window, $http, $q, x2js, server, tinv) {
    function translateErrors(err) {
        if (err.data && err.data.error)
            throw new Error('TInv error: ' + err.data.error);
        throw err;
    }
    return {
        list: function (cedente, password) {
            return $http({
                method: 'GET',
                url: server + 'invoice',
                headers: { 'X-Authorization': $window.btoa(cedente + ':' + password) },
            }).then(function (result) {
                return result.data.invoice;
            }, translateErrors);
        },
        download: function(cedente, password, file) {
            return $http({
                method: 'GET',
                url: server + 'invoice/' + file,
                headers: { 'X-Authorization': $window.btoa(cedente + ':' + password) },
            }).then(function (result) {
                return result.data;
            }, translateErrors);
        },
        accept: function(cedente, password, file) {
            return $http({
                method: 'POST',
                url: server + 'invoice/' + file+ '/accept',
                headers: { 'X-Authorization': $window.btoa(cedente + ':' + password) },
            }).then(function (result) {
                return result.data;
            }, translateErrors);
        },
        refuse: function(cedente, password, file, reason) {
            return $http({
                method: 'POST',
                url: server + 'invoice/' + file+ '/refuse',
                data: reason,
                headers: { 'X-Authorization': $window.btoa(cedente + ':' + password) },
            }).then(function (result) {
                return result.data;
            }, translateErrors);
        },
        info: function(cedente, password) {
            return $http({
                method: 'POST',
                url: tinv + '/userREST/user/info',
                data: {
                    Autenticazione: {
                        Cedente: {
                            IdPaese: 'IT',
                            IdCodice: cedente
                        },
                        Password: password
                    }
                }
            }).then(function (result) {
                return result.data;
            }, translateErrors);
        },
        send: function(cedente, password, destinatario, committente, body) {
            if (!destinatario)
                return $q.reject(new Error('No receiver inserted.'));
            var data = {
                Autenticazione: {
                    Cedente: {
                        IdPaese: 'IT',
                        IdCodice: cedente
                    },
                    Password: password
                },
                CessionarioCommittenteStr: x2js.json2xml_str({ CessionarioCommittente: committente }),
                FatturaElettronicaBodyStr: x2js.json2xml_str({ FatturaElettronicaBody: body })
            };
            if (destinatario.indexOf('@') < 0)
                data.CodiceDestinatario = destinatario;
            else
                data.PECDestinatario = destinatario;
            return $http({
                method: 'POST',
                url: tinv + '/userREST/active/send',
                data: data
            }).then(function (result) {
                return result.data.ProgressivoInvio;
            }, translateErrors);
        },
        upload: function(cedente, password, filename, type, content) {
            if (!content)
                return $q.reject(new Error('No content found.'));
            return $http({
                method: 'POST',
                url: server + 'upload/'+ filename,
                data: content,
                transformRequest: angular.identity,
                headers: { 'X-Authorization': $window.btoa(cedente + ':' + password), 'Content-Type': type }
            }).then(function (result) {
                return result.data;
            }, translateErrors);
        },
    };
});
